export enum EnvironmentType {
  DEVELOPMENT = 'development',
  STAGING = 'staging',
  PRODUCTION = 'production',
}

export function getEnvironmentType(): EnvironmentType {
  const { host } = location;

  if (host.startsWith('localhost') || host.includes('.test')) {
    return EnvironmentType.DEVELOPMENT;
  }

  if (host.includes('staging')) {
    return EnvironmentType.STAGING;
  }
  
  return EnvironmentType.PRODUCTION;
}
